import commonConfig from "@/const/config.js";

const apiBaseURLConst = commonConfig.erpBaseUrl;
console.log("---apiBaseURLConst", apiBaseURLConst);
export default apiBaseURLConst;



// WEBPACK FOOTER //
// ./src/utils/baseUrl.js